export const monthList = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" }
];

export const leaves=[
{code:'CL', name:"Casual Leave"},
{code:'SL', name:"Sick Leave"},
{code:'EL', name:"Earn Leave"},
{code:'RL', name:"Recreation Leave"}
];

export const empCategory=[
{code:'O', name:"Officer"},
{code:'S', name:"Staff"},
{code:'W', name:"Worker"},
];

export const empType=[
{code:'PER', name:"Permanent"},
{code:'PRO', name:"Provissional"},
{code:'OUT', name:"Outsourcing"},
];

export const empGrade=[
{id:1, name:"1"},
{id:2, name:"2"},
{id:3, name:"3"},
{id:4, name:"4"},
{id:5, name:"5"},
{id:6, name:"6"},
{id:7, name:"7"},
{id:8, name:"8"},
{id:9, name:"9"},
{id:10, name:"10"},
{id:11, name:"11"},
{id:12, name:"12"},
{id:13, name:"13"},
{id:14, name:"14"},
{id:15, name:"15"},
{id:16, name:"16"},
{id:17, name:"17"},
{id:18, name:"18"},
{id:19, name:"19"},
];

export const bloogGroup=[
{code:'O+', name:"O+"},
{code:'O-', name:"O-"},
{code:'A+', name:"A+"},
{code:'A-', name:"A-"},
{code:'AB+', name:"AB+"},
{code:'B+', name:"B+"},
{code:'B-', name:"B-"},
];

export const assetCategory=[
{code:'Desktop', name:"Desktop"},
{code:'Laptop', name:"Laptop"},
{code:'Printer', name:"Printer"},
{code:'Scanner', name:"Scanner"},
{code:'Monitor', name:"Monitor"},
{code:'UPS', name:"UPS"},
];

export const medecinComp=[
{name:"Square Pharmaceuticals PLC"},
{name:"Beximco Pharmaceutical PLC"},
{name:"Healthcare Pharmaceuticals Ltd."},
{name:"Incepta Pharmaceuticals Ltd."},
{name:"Popular Pharmaceuticals Ltd."},
{name:"Unihealth Pharmaceuticals Ltd."},
{name:"Drug International Ltd."},
{name:"Essential Drugs Company Limited"},
];

export const medecinuom=[
{name:"Pcs"},
{name:"Nos"},
{name:"Packet"},
{name:"Bundle"},
{name:"Kg"},
{name:"Botol"},
{name:"Pot"},
{name:"Roll"},
{name:"Num"},
]



